import CreatorsTable from "@/components/creators-table/CreatorsTable";
import { Creator } from "@/types/types";
import { CreatorOptions } from "@/stores/shareStore";

/** Read-only creator roster for a public share link. */
export default function ShareCreatorsBody({
  creators,
  options,
  token,
}: {
  creators: Creator[];
  options: CreatorOptions;
  token: string;
}) {
  return (
    <div className="h-full w-full pt-4 pb-2">
      <CreatorsTable
        data={creators}
        setData={() => {}}
        readOnly
        showStats={options.show_stats}
        showFields={options.show_fields}
        showConversations={options.show_conversations}
        shareToken={token}
      />
    </div>
  );
}
